
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, DOCUMENT, inject } from '@angular/core';
import { environment } from '@mogenius/environments/environment';
import { DesignModeService } from '@mogenius/shared/services/design-mode/design-mode.service';
import { SocketEventsService } from '@mogenius/studio/services/socket-events/socket-events.service';
import { RouterOutlet } from '@angular/router';
import { LoggedOutSidebarComponent } from '../../components/logged-out-sidebar/logged-out-sidebar.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'mo-logged-out.user-outlet',
    templateUrl: './logged-out.user-outlet.component.html',
    styleUrls: ['./logged-out.user-outlet.component.scss'],
    imports: [RouterOutlet, LoggedOutSidebarComponent, NgOptimizedImage],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoggedOutUserOutletComponent implements OnInit, OnDestroy {
  private readonly _socketEventsService = inject(SocketEventsService);
  protected readonly _document = inject<Document>(DOCUMENT);
  private readonly _designModeService = inject(DesignModeService);

  private readonly _version: string;

  constructor() {
    const stage = environment.stage === 'prod' ? '' : ` - ${environment.stage}`;
    this._version = `v.${environment.version}${stage}`;
  }

  ngOnInit(): void {
    this._socketEventsService.initEventsUserService();
    const html = this._document.getElementsByTagName('html')[0];
    html.setAttribute('data-bs-theme', 'dark');
  }

  ngOnDestroy(): void {
    this._designModeService.init();
  }

  get version(): string {
    return this._version;
  }
}
